// db.js
import Dexie from "dexie";

export const db = new Dexie("aglets-b2b");
db.version(2).stores({
  componente:
    "++componente_id,descricao,ordem,identificador,tipo_id,pagina_id,updated_at,tipo,pagina,imagens_validas", // Primary key and indexed props
});
